'use strict';
'use es6';

require('./polyFills');

var _SprocketMenu = require('./SprocketMenu');

var _SprocketMenu2 = _interopRequireDefault(_SprocketMenu);

var _PostFilterWidget = require('./PostFilterWidget');

var _PostFilterWidget2 = _interopRequireDefault(_PostFilterWidget);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

document.addEventListener('DOMContentLoaded', function init() {
  var menu = new _SprocketMenu2.default(window.hsVars);
  menu.showToolsMenuIfAuthor();
  var postFilterWidget = new _PostFilterWidget2.default();
  postFilterWidget.setup();
  document.removeEventListener('DOMContentLoaded', init);
}, false);


//////////////////
// WEBPACK FOOTER
// ./js/index.js
// module id = 0
// module chunks = 0 1